import { render } from "./IconComponent.vue?vue&type=template&id=88c649e0"
import script from "./IconComponent.vue?vue&type=script&lang=js"
export * from "./IconComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__